module.exports = __webpack_public_path__ + "static/media/Stellar Ark Queen Headboard - 155 cm_Natural.96007c1b.png";